import z, { ZodType } from 'zod';

export type PlayerMessageItem = {
	id: number;
	order: number;
	balance: number;
	isConnected: boolean;
};

export const playerMessageItemSchema: ZodType<PlayerMessageItem> = z.object({
	id: z.number(),
	order: z.number(),
	balance: z.number(),
	isConnected: z.boolean(),
});
